import React from 'react';
import { Link } from 'react-router-dom';

const Banner = ({ appName, token }) => {
  if (token) {
    return null;
  }
  return (
    <div className="banner">    
    <div className="container">
    <nav className="navbar navbar-expand-lg navbar-dark">
      <div className="d-flex flex-grow-1">
        
        <div class="w-100 text-right">
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#myNavbar">
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
      </div>
      <div class="collapse navbar-collapse text-right" id="myNavbar">
        <ul className="navbar-nav mr-auto flex-nowrap">
          <li className="nav-item">
            <Link to="/" className="nav-link m-2 menu-item">
              Sākums
          </Link>
          </li>

          <li className="nav-item dropdown">
            <Link to="/monuments" className="nav-link m-2 menu-item dropdown-toggle" aria-haspopup="true" aria-expanded="false">
              Pieminekļi un piemiņas plāksnes
          </Link>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <Link to="/monuments-black" className="dropdown-item">
                Melni
            </Link>
              <Link to="/monuments-brownandgray" className="dropdown-item">
                Brūni un pelēki
            </Link>
              <Link to="/monuments-boulders" className="dropdown-item">
                Laukakmeņi
            </Link>
              <Link to="/monuments-polished" className="dropdown-item">
                Pulētām malām
            </Link>
            </div>
          </li>

          <li className="nav-item">
            <Link to="/borders" className="nav-link m-2 menu-item">
              Apmales
          </Link>
          </li>

          <li className="nav-item">
            <Link to="/outerborders" className="nav-link m-2 menu-item">
              Laukumi
          </Link>
          </li>

          <li className="nav-item">
            <Link to="/contacts" className="nav-link m-2 menu-item">
              Kontakti
          </Link>
          </li>
        </ul>        
      </div>
    </nav>
  </div>
  </div>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Home/Banner.js